import {createSlice} from "@reduxjs/toolkit";

export const dashboardSlice = createSlice({
    name: 'dashboard',
    initialState: {
        selectedLocation: null,
    },
    reducers: {
        setSelectedLocation(state, {payload}) {
            state.selectedLocation = payload
        }
    }
})

export const { setSelectedLocation} = dashboardSlice.actions
